var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"currency"},[(_vm.value)?[_vm._l((_vm.thousands),function(v,idx){return _c('span',{key:`t-${_vm.value}-${idx}`,staticClass:"t"},[_vm._v(_vm._s(v))])}),(_vm.decimals !== false)?_c('span',{staticClass:"d"},[_vm._v("."+_vm._s(_vm.decimals))]):_vm._e(),_c('span',{staticClass:"c"},[_vm._v(" "+_vm._s(_vm.currency))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }